import React, {
    useEffect,
    useMemo,
    useRef,
    useState
} from 'react';

import './EducationManifesto.css';
import './EducationManifesto.mobile.css';


const DATA = {

    academic: {
        key: 'academic',
        index: '01',
        title: "L'Institutionnel",

        blocks: [
            {
                index: '01',
                domain: 'Paris Nanterre',
                period: '2014 — 2018',

                categories: [
                    {
                        name: 'Sociologie & LEA',
                        items: [
                            'Analyse sociale',
                            'Communication multilingue'
                        ]
                    },
                    {
                        name: 'Compétences',
                        items: [
                            'Synthèse critique',
                            'Rigueur méthodologique',
                            'Connaissance du monde Anglo-Saxon',
                            'Connaissance du monde Hispanique'
                        ]
                    }
                ]
            },

            {
                index: '02',
                domain: 'École 42',
                period: '2021 — 2026',

                categories: [
                    {
                        name: 'Engineering',
                        items: [
                            'Algorithmique C/C++',
                            'Architecture système',
                            'Système et bas niveau'
                        ]
                    },
                    {
                        name: 'Méthodologie',
                        items: [
                            'Peer-learning',
                            'Problem solving',
                            'Travail en équipe'
                        ]
                    }
                ]
            }
        ]
    },


    selfTaught: {
        key: 'selfTaught',
        index: '02',
        title: "L'Exploration",

        blocks: [
            {
                index: '03',
                domain: 'Langues',
                period: '2014 — Présent',

                categories: [
                    {
                        name: 'Immersion',
                        items: [
                            'HelloTalk (Natifs)',
                            'Radio Garden',
                            'TV Garden'
                        ]
                    },
                    {
                        name: 'Contenu',
                        items: [
                            'Podcasts Spotify',
                            'Littérature',
                            'Youtube',
                            'Journaux'
                        ]
                    }
                ]
            },

            {
                index: '04',
                domain: 'Code & IA',
                period: '2021 — Présent',

                categories: [
                    {
                        name: 'Technique',
                        items: [
                            'Documentation (Sources)',
                            'Open Source',
                            'Exercism/Codewar'
                        ]
                    },
                    {
                        name: 'Moderne',
                        items: [
                            'IA Générative',
                            'Workflows Agents'
                        ]
                    }
                ]
            }
        ]
    },


    timeline: [
        {
            year: '2014',
            tags: [
                'SOCIOLOGIE',
                'ANTHROPOLOGIE',
                'DEMOGRAPHIE',
                'SOCIOLOGIE DU TRAVAIL'
            ]
        },

        {
            year: '2015',
            tags: [
                'ESPAGNOL',
                'TRADUCTION',
                'SYNTHÈSE'
            ]
        },

        {
            year: '2016',
            tags: [
                'ITALIEN',
                'RUSSE',
                'CIVILISATION SLAVE'
            ]
        },

        {
            year: '2017',
            tags: [
                'PORTUGAIS',
                'CIVILISATION LUSOPHONE'
            ]
        },

        {
            year: '2018',
            tags: [
                'DECOUVERTE AUTODIDACTE DU C',
                'INITIATION AU CODE'
            ]
        },

        {
            year: '2019',
            tags: [
                'RUBY',
                'HTML/CSS',
                'LINUX/UNIX',
                'GIT'
            ]
        },

        {
            year: '2021',
            tags: [
                'C',
                'BASH',
                'ALGO',
                'SCRIPTING'
            ]
        },

        {
            year: '2022',
            tags: [
                'C++',
                'PYTHON',
                'RESEAU'
            ]
        },

        {
            year: '2023',
            tags: [
                'VIRTUALISATION',
                'JAVASCRIPT',
                'PHP'
            ]
        },

        {
            year: '2024',
            tags: [
                'GEN AI',
                'AGENTS',
                'FFMPEG'
            ]
        },

        {
            year: '2025',
            tags: [
                'DJANGO',
                'REACT',
                'DOCKER'
            ]
        }
    ]
};


const TimelineNode = ({
    item,
    isClone = false
}) => (

    <div
        className={
            isClone
                ? 'timeline-node timeline-node--clone'
                : 'timeline-node'
        }
        aria-hidden={
            isClone
                ? 'true'
                : undefined
        }
    >

        <div className="node-year">
            {item.year}
        </div>


        <div className="node-tags">

            {item.tags.map(
                (tag, index) => (

                    <span
                        key={index}
                        className="node-tag"
                    >
                        {tag}
                    </span>

                )
            )}

        </div>

    </div>

);


const EducationCard = ({
    block,
    track
}) => (

    <article
        className={`
            block-card
            block-card--${track}
            education-card-${block.index}
        `}
    >

        <header className="card-header">

            <div className="card-index">
                {block.index}
            </div>


            <div className="card-heading">

                <span className="card-track-label">
                    {
                        track === 'academic'
                            ? 'INSTITUTIONNEL'
                            : 'EXPLORATION'
                    }
                </span>


                <h3 className="card-domain">
                    {block.domain}
                </h3>


                <span className="card-period">
                    {block.period}
                </span>

            </div>

        </header>


        <div className="card-content">

            {block.categories.map(
                (category, categoryIndex) => (

                    <section
                        key={categoryIndex}
                        className="content-section"
                    >

                        <h4 className="section-title">
                            {category.name}
                        </h4>


                        <ul className="section-list">

                            {category.items.map(
                                (item, itemIndex) => (

                                    <li key={itemIndex}>
                                        {item}
                                    </li>

                                )
                            )}

                        </ul>

                    </section>

                )
            )}

        </div>

    </article>

);


const EducationManifesto = () => {

    const [activeTrack, setActiveTrack] =
        useState('academic');


    const mobileCarouselRef =
        useRef(null);


    const activeData =
        activeTrack === 'academic'
            ? DATA.academic
            : DATA.selfTaught;


    const desktopCards = useMemo(
        () => [
            {
                block: DATA.academic.blocks[0],
                track: 'academic'
            },
            {
                block: DATA.selfTaught.blocks[0],
                track: 'selfTaught'
            },
            {
                block: DATA.academic.blocks[1],
                track: 'academic'
            },
            {
                block: DATA.selfTaught.blocks[1],
                track: 'selfTaught'
            }
        ],
        []
    );


    useEffect(
        () => {

            if (!mobileCarouselRef.current) {
                return;
            }

            mobileCarouselRef.current.scrollTo({
                left: 0,
                behavior: 'auto'
            });

        },
        [activeTrack]
    );


    return (

        <div className="manifesto-wrapper">


            {/* =====================================================
                HEADER
                ===================================================== */}

            <header className="manifesto-header">

                <div className="header-content">

                    <h1 className="manifesto-title">
                        Education Manifesto
                    </h1>


                    <div className="header-meta">

                        <span className="meta-text">
                            Fusion Hybrid : Académique vs Autodidacte
                        </span>


                        <span className="meta-version">
                            VER_2026.SYS
                        </span>

                    </div>

                </div>

            </header>


            {/* =====================================================
                INFINITE TIMELINE
                ===================================================== */}

            <section
                className="timeline-section"
                aria-label="Frise chronologique de formation"
            >

                <div className="timeline-track">

                    {DATA.timeline.map(
                        (item, index) => (

                            <TimelineNode
                                key={`timeline-a-${index}`}
                                item={item}
                            />

                        )
                    )}


                    {DATA.timeline.map(
                        (item, index) => (

                            <TimelineNode
                                key={`timeline-b-${index}`}
                                item={item}
                                isClone
                            />

                        )
                    )}

                </div>

            </section>


            {/* =====================================================
                DESKTOP
                ===================================================== */}

            <main className="education-desktop-stage">

                <div className="education-desktop-trackbar">

                    <div className="education-trackbar-item education-trackbar-item--academic">

                        <span className="education-trackbar-number">
                            01
                        </span>

                        <span className="education-trackbar-title">
                            L'INSTITUTIONNEL
                        </span>

                        <span className="education-trackbar-count">
                            02 DOSSIERS
                        </span>

                    </div>


                    <div className="education-trackbar-item education-trackbar-item--exploration">

                        <span className="education-trackbar-number">
                            02
                        </span>

                        <span className="education-trackbar-title">
                            L'AUTODIDACTE
                        </span>

                        <span className="education-trackbar-count">
                            02 DOSSIERS
                        </span>

                    </div>

                </div>


                <div className="education-desktop-grid">

                    {desktopCards.map(
                        ({
                            block,
                            track
                        }) => (

                            <EducationCard
                                key={block.index}
                                block={block}
                                track={track}
                            />

                        )
                    )}

                </div>

            </main>


            {/* =====================================================
                MOBILE
                ===================================================== */}

            <main className="education-mobile-stage">


                {/* ===============================================
                    TRACK SELECTOR
                    =============================================== */}

                <div
                    className="education-mobile-switcher"
                    role="tablist"
                    aria-label="Type de formation"
                >

                    <button
                        type="button"
                        role="tab"
                        aria-selected={
                            activeTrack === 'academic'
                        }
                        className={
                            activeTrack === 'academic'
                                ? 'education-mobile-tab is-active'
                                : 'education-mobile-tab'
                        }
                        onClick={
                            () => setActiveTrack('academic')
                        }
                    >

                        <span className="education-mobile-tab-number">
                            01
                        </span>

                        <span className="education-mobile-tab-label">
                            Institutionnel
                        </span>

                    </button>


                    <button
                        type="button"
                        role="tab"
                        aria-selected={
                            activeTrack === 'selfTaught'
                        }
                        className={
                            activeTrack === 'selfTaught'
                                ? 'education-mobile-tab is-active'
                                : 'education-mobile-tab'
                        }
                        onClick={
                            () => setActiveTrack('selfTaught')
                        }
                    >

                        <span className="education-mobile-tab-number">
                            02
                        </span>

                        <span className="education-mobile-tab-label">
                            AUTODIDACTE
                        </span>

                    </button>

                </div>


                {/* ===============================================
                    SINGLE CAROUSEL
                    =============================================== */}

                <div
                    ref={mobileCarouselRef}
                    className="education-mobile-carousel"
                    role="tabpanel"
                >

                    {activeData.blocks.map(
                        (block) => (

                            <EducationCard
                                key={`${activeTrack}-${block.index}`}
                                block={block}
                                track={activeTrack}
                            />

                        )
                    )}

                </div>

            </main>

        </div>

    );

};


export default EducationManifesto;